import { useEffect, useRef, useState } from 'react'
import Container from './container'

export default function Video() {
  const [isPlaying, setIsPlaying] = useState(false)
  const videoRef = useRef(null)

  const handlePlay = () => {
    setIsPlaying(true)
  }

  useEffect(() => {
    // Criar uma instância do Intersection Observer
    const observer = new IntersectionObserver(
      entries => {
        // Verificar se o elemento está visível na tela
        if (entries[0].isIntersecting && !isPlaying) {
          setIsPlaying(true)
        }
      },
      {
        // Configurações do observer: ativar quando 70% do elemento estiver visível
        threshold: 0.7,
        rootMargin: '0px',
      },
    )

    // Observar o elemento de vídeo
    if (videoRef.current) {
      observer.observe(videoRef.current)
    }

    // Limpar o observer quando o componente for desmontado
    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current)
      }
    }
  }, [isPlaying])

  return (
    <div className="w-full bg-[#040116] lg:pt-12 pb-8 lg:pb-0">
      <Container>
        <div
          ref={videoRef}
          className="relative md:aspect-video w-full rounded-lg overflow-hidden"
        >
          {!isPlaying ? (
            <>
              <img
                src="https://img.youtube.com/vi/9sHfoXbOsu4/maxresdefault.jpg"
                alt="Video thumbnail"
                className="w-full h-full object-cover"
              />
              {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
              <div
                className="absolute inset-0 flex items-center justify-center cursor-pointer"
                onClick={handlePlay}
              >
                <div className="w-24 h-24 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center">
                  <img
                    src="/assets/play.svg"
                    alt="Play"
                    className="w-20 h-20"
                  />
                </div>
              </div>
            </>
          ) : (
            <iframe
              src="https://www.youtube.com/embed/9sHfoXbOsu4?autoplay=1&rel=0&mute=1"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full h-[300px] lg:h-[500px]"
            />
          )}
        </div>
      </Container>
    </div>
  )
}
